<template>
  <span class="payment-headline">{{ $props.title }}</span>
</template>

<script>
export default {
  name: 'checkout-payment-headline',
  props: {
    title: String
  }
}
</script>

<style lang="scss" scoped>
.payment-headline {
  display: block;
  margin-bottom: 1.8rem;
  color: $black;
  font-size: 2rem;

  @media (map_get($breakpoints, sm)) {
    margin-bottom: 1.6rem;
    color: $text;
    font-size: 2.6rem;
  }
}
</style>
